import jComponentList from './ext-component-list';
import { coreComponentsMapping } from './core-component-list';
import { commonComponentsRegistry } from './CommonRegistry';
import { coreComponentsRegistry } from './CoreRegistry';

export function initCommonComponents() {
    commonComponentsRegistry.registerLib(jComponentList, import('jamespot-react-components'));
}

export function initCoreComponents() {
    coreComponentsRegistry.registerLib(coreComponentsMapping, import('./coreComponents'));
}
